import { create } from 'fedops-logger';
import { isSSR } from './is-ssr';

const noop = () => {};

export const createFedopsLogger = fedopsAppName => {
  if (isSSR() || window.__IS_DEV_MODE__) { // can't use fedops on server side
    return {
      interactionStarted: noop,
      interactionEnded: noop,
      appLoaded: noop,
    };
  } else {
    return create(fedopsAppName);
  }
};



// WEBPACK FOOTER //
// ./app/services/create-fedops-logger.js